import { useState, useEffect, useRef, createContext } from 'react';
import FirstMilePage from '../first_mile_pages/first_mile_page';
import CircularProgress from '@mui/material/CircularProgress';
import User from '../models/user_deatils_model';
import { ApiEndPoint } from "../../network/api_end_point";
import axios from "axios";
import storageService from "../../utils/storage_service";
import { decryptToken } from "../../components/decryption_algo";
import StringUtils from "../../utils/string_utils";

const AssignedHubContext = createContext();

const FirstMileController = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [uidLoaded, setUidLoaded] = useState(false);
    const initialCall = useRef(true);//for the first time call
    const [assignedHub, setAssignedHub] = useState([]);
    const [userPermissions, setUserPermissions] = useState(null);
    const [isFromUrl, setIsFromUrl] = useState(false);

    const apiEndPoint = new ApiEndPoint();
    useEffect(() => {
        const checkUid = () => {
            const uid = localStorage.getItem('uid');
            if (uid) {
                setUidLoaded(true);
            } else {
                const interval = setInterval(() => {
                    const uidCheck = localStorage.getItem('uid');
                    if (uidCheck) {
                        setUidLoaded(true);
                        clearInterval(interval);
                    }
                }, 1000);
                return () => clearInterval(interval); // Check every 1 second
            }
        };
        checkUid();
    }, []);

    useEffect(() => {
        if (initialCall.current) {
            const iv = StringUtils.iv;
            const extractQueryParams = window.location.search
            const urlParamsData = new URLSearchParams(extractQueryParams);

            const uidParam = urlParamsData.get("uid");
            const tokenParam = urlParamsData.get("t");

            if (uidParam && tokenParam) {
                setIsFromUrl(true);
                try {
                    const encryptedUid = uidParam.replace(/ /g, "+");
                    const encryptedToken = tokenParam.replace(/ /g, "+");
                    const encryptedrToken = urlParamsData.get("rt")?.replace(/ /g, "+");

                    const uid = decryptToken(JSON.stringify({ encryptedToken: encryptedUid, iv }), StringUtils.frameKey);
                    const token = decryptToken(JSON.stringify({ encryptedToken: encryptedToken, iv }), StringUtils.frameKey);
                    const rtoken = decryptToken(JSON.stringify({ encryptedToken: encryptedrToken, iv }), StringUtils.frameKey);

            const channelId = urlParamsData.get('ch');
                    if (uid && token) {
                        handleAuthentication(uid, token, rtoken, channelId);
                    } else {
                        setIsAuthenticated(false);
                    }
                } catch (error) {
                    console.error("Error decrypting data from URL:", error);
                    setIsAuthenticated(false);
                }
            } else {
                setIsFromUrl(false);
                const channelId = JSON.parse(localStorage.getItem("userAuthentications"))?.channelId;
                const { uid, token, rtoken } = JSON.parse(localStorage.getItem("userData")) ?? {};

                if (uid && token) {
                    handleAuthentication(uid, token, rtoken, channelId);
                } else {
                    setIsAuthenticated(false);
                }
            }
            initialCall.current = false;
        }
        // eslint-disable-next-line
    }, [])

    const handleAuthentication = async (uid, token, rtoken, channelId) => {
        try {
            isFromUrl && localStorage.clear();
            const userData = await fetchUserData(uid);

            storeAuthenticationData(uid, token, rtoken, channelId, userData);
            setIsAuthenticated(true);
        } catch (e) {
            console.error('Error during authentication:', e);
            setIsAuthenticated(false)
        }
    }
    const fetchUserData = async (uid) => {
        try {
            isFromUrl && localStorage.clear();
            const userDataResponse = await axios.get(apiEndPoint.authBaseUrl + apiEndPoint.userDetailsUrl, {
                params: {
                    uid: uid
                }
            })
            return userDataResponse.data
        } catch (e) {
            console.error('Error fetching user permissions:', e);
            throw e;
        }
    }

    const storeAuthenticationData = (uid, token, rtoken, channelId, user) => {
        isFromUrl && localStorage.clear();

        storageService.setItem('uid', uid);
        storageService.setItem('token', JSON.stringify(token));
        storageService.setItem('rtoken', JSON.stringify(rtoken));
        storageService.setItem('channelId', channelId);
        storageService.setItem('user', JSON.stringify(user));

        console.log(user);
        if (user && user.status === true) {
            const userPermissions = new User(user);
            const filteredHubLocations = userPermissions.assignedLocations.filter(item => {
                return (
                item.location_type_code.toUpperCase() === 'CWH'
            );
            })
            setAssignedHub(filteredHubLocations);
            setUserPermissions(userPermissions);
            // localStorage.setItem('userPermissions', JSON.stringify(userPermissions));
            localStorage.setItem('clientLocationName', userPermissions.clientLocationName)
            localStorage.setItem('clientLocationId', userPermissions.clientLocationId)
            localStorage.setItem('firstName', userPermissions.firstName)
        }
    };

    return (
        <div>
            {isAuthenticated && uidLoaded ? (
                <AssignedHubContext.Provider value={assignedHub}>
                    <FirstMilePage isFromUr={isFromUrl} />
                </AssignedHubContext.Provider>
            ) : (
                <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)'
                }}>

                    <CircularProgress />

                </div>
            )}
        </div>
    )
}
export default FirstMileController;
export { AssignedHubContext };

